




























import Component from "vue-class-component";
import Vue from "vue";
import Pagination from "@/common-class/pagination";
import moduleStore from "./store/index";
import moment from "moment";
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
@Component({
  components: {},
})
export default class indexPage extends Pagination {
  list: any[] = []
  moment=moment
  mounted() {
  }
   async getList() {
    try {
      const res = await (this as any).getHistory({
        page: this.currentPage,
        size: this.pageSize,
      });

      if (res.code == 200) {
        this.list.push(...res.data.results);
        this.totalPage = res.data.total_pages;
      }
      this.refreshing = false;
      this.loading = false;
      if (res.code != 200) this.error = true;
    } catch (err) {
      this.refreshing = false;
      this.loading = false;
      this.error = true;
    }
  }
  onRefresh() {
    // 下拉刷新
    this.refresh(() => {
      this.list = [];
      this.getList();
    });
  }
  onLoad() {
    // 上拉滚动加载
    console.log("加载");
    this.loadMore(() => {
      this.getList();
    });
  }
  goDetail(item){
    this.$router.push(`/order/invoicDetail?submitId=${item.id}&info=${JSON.stringify({...item,createAt:  moment(item.createAt).format("YYYY-MM-DD HH:mm:ss")})}`)
  }
}
